import React from "react";
import { useTranslation } from "react-i18next";
import { AiOutlineClose } from "react-icons/ai";
import styles from "./ModalConfirmRegisterNewValue.module.scss";

const ModalConfirmDefaultCalib = ({
  setOverlay,
  setModalOpen,
  onConfirm,
  type, // "Headphones" ou "Inserts"
}) => {
  const { t } = useTranslation();

  const handleCancel = () => {
    setOverlay(false);
    setModalOpen(false);
  };

  const label = type === "Headphones" ? "Casque" : "Inserts";

  return (
    <>
      <div className={styles.wrapperModal} onClick={handleCancel} />
      <div className={styles.containerModal}>
        <button
          className={`${styles.closeBtn} has-tooltip`}
          onClick={handleCancel}
          aria-label={t("common.close")}
        >
          <AiOutlineClose />
        </button>

        <h4 className={styles.modalTitle}>
          Injecter les calibrations par défaut ({label})
        </h4>

        <p style={{ margin: 0, fontSize: "0.85em", opacity: 0.85 }}>
          Les données de calibration par défaut vont être injectées avec la date du jour.
          Voulez-vous continuer ?
        </p>

        <div className={styles.actions}>
          <button className={styles.btnCancel} onClick={handleCancel}>
            {t("common.cancel")}
          </button>
          <button
            className={styles.btnConfirm}
            onClick={() => {
              onConfirm();
              handleCancel();
            }}
          >
            Injecter
          </button>
        </div>
      </div>
    </>
  );
};

export default ModalConfirmDefaultCalib;
